import { extractVersionFromArrayBuffer } from '@/components/fileExtract/extractVersion';
import SparkMD5 from 'spark-md5';
import { groupBy } from 'lodash-es';

// 遍历树形
export const getMapTree = (
  treeList: any[],
  fieldName: any = { key: 'id', children: 'children', title: 'name' },
) => {
  return treeList.map((item: any) => {
    let children: any[] = [];
    if (item?.children.length) {
      children = getMapTree(item.children, fieldName);
    }
    const result: any = {};
    Object.keys(fieldName).forEach((key) => {
      if (key === 'children') {
        result[key] = children;
      } else {
        result[key] = item[fieldName[key]];
      }
    });
    return result;
  });
};

// 遍历查找
export const deepfind: (arr: any, key: any, value: string, isReplaceSpace?: boolean) => any = (
  arr: any,
  key: any,
  value: string,
  isReplaceSpace?: boolean,
) => {
  if (!arr?.length || !value) {
    return null;
  }
  for (let i = 0; i < arr.length; i++) {
    let targetValue = arr[i][key] || '';
    if (isReplaceSpace) {
      const reg = /\s+/g;
      targetValue = targetValue?.replace(reg, '');
    }
    if (targetValue === value) {
      return arr[i];
    }
    if (arr[i]?.children && arr[i].children.length) {
      const result = deepfind(arr[i].children, key, value);
      if (result) return result;
    }
  }
};

export const computeMD5 = (file: any) => {
  return new Promise((resolve, reject) => {
    const blobSlice = File.prototype.slice;
    const chunkSize = 1024 * 1024 * 5;
    const chunks = Math.ceil(file.size / chunkSize);
    let currentChunk = 0;
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();
    file.cmd5 = true; //文件状态为“计算md5...”
    file.fileName = file.name;
    const loadNext = () => {
      const start = currentChunk * chunkSize;
      const end = start + chunkSize >= file.size ? file.size : start + chunkSize;

      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    };

    fileReader.onload = (e) => {
      spark.append(e?.target?.result as ArrayBuffer); // Append array buffer
      currentChunk++;

      if (currentChunk < chunks) {
        const num = currentChunk / chunks;
        file.md5Percent = num.toFixed(2);
        loadNext();
      } else {
        const md5 = spark.end(); //得到md5
        file.md5 = md5;
        file.md5Percent = 1.0;
        resolve(md5);
        spark.destroy(); //释放缓存
        file.uniqueIdentifier = md5; //将文件md5赋值给文件唯一标识
        file.cmd5 = false; //取消计算md5状态
        // file.resume(); //开始上传
      }
    };

    fileReader.onerror = () => {
      reject();
      console.warn('oops, something went wrong.');
      file.cancel();
    };

    loadNext();
  });
};

export const extractVersion = (file: File) => {
  const type = file.name.split('.').pop()?.toLowerCase();
  if (type !== 'rvt' && type !== 'rfa') {
    return new Promise((resolve) => resolve(''));
  }
  return new Promise<string>((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = async () => {
      const version = await extractVersionFromArrayBuffer(fileReader.result as ArrayBuffer);
      resolve(version && version.trim());
    };
    fileReader.onerror = (e) => {
      reject(e);
    };
  });
};
